const { createContext, useState, useEffect } = require('react')

export const ActionContext = createContext()

export function ActionProvider({ children }) {
  const [isChangeBackgroundHeader, setIsChangeBackgroundHeader] =
    useState(false)
  const [isHideFt, setIsHideFt] = useState(false)
  const [isVideoPlaying, setIsVideoPlaying] = useState(true)
  const [isHideVideo, setIsHideVideo] = useState(false)
  const [statusChoose, setStatusChoose] = useState('')

  const [moneyChoose, setMoneyChoose] = useState('')

  useEffect(() => {
    if (statusChoose) {
      setTimeout(() => {
        setStatusChoose('')
      }, 2000)
    }
  }, [statusChoose])

  const state = {
    isChangeBackgroundHeader,
    isHideFt,
    isVideoPlaying,
    isHideVideo,
    statusChoose,
    moneyChoose,
  }

  const setState = {
    setIsChangeBackgroundHeader,
    setIsHideFt,
    setIsHideVideo,
    setIsVideoPlaying,
    setStatusChoose,
    setMoneyChoose,
  }

  const values = {
    state,
    setState,
  }

  return (
    <ActionContext.Provider value={values}>{children}</ActionContext.Provider>
  )
}
